// @ngInject
function FileOperationsApiService($q, $cookies, $window, DS, DSHttpAdapter, ResourcesService) {

    return {
        downloadLabels: downloadLabels,
        downloadPdfFile: downloadPdfFile
    };

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s]){1,}.pdf/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function downloadLabels(fileName) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'file/labels/' + fileName, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'labels.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadPdfFile(fileName) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'file/' + fileName, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'file.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('fileoperations.api', [])
    .factory('FileOperationsApiService', FileOperationsApiService);
